<template>
  <div class="wap Home">
    <DrawerYayout
      :isOpen="openMeun"
      @closeMe="closeMe"
      :scrollY="scrollY"
    />
    <section
      class="h5-page-1"
      id="01"
      :style="{ 'background-image': `url(${backgroundImage1})` }"
    >
      <Star
        :nums="100"
        :heights="500"
        :scalex="5"
        :scaley="4"
      />
      <div class="head">
        <svg-icon
          @click="leftMenuHandle"
          class="menu-logo"
          icon-file-name="menu"
        ></svg-icon>
        <img
          class="hooked-logo"
          v-lazy="require('../../assets/images/home/logo.png')"
          alt=""
        />
      </div>
      <div class="build-box">
        <img
          v-lazy="require('../../assets/images/home/Word.png')"
          alt=""
        />
      </div>
      <img
        class="hand-pointer"
        v-lazy="require('../../assets/images/home/hand.png')"
        alt=""
      />
    </section>
    <section
      class="h5-page-2"
      id="02"
      :style="{ 'background-image': `url(${backgroundImage2})` }"
    >
      <Star
        :nums="220"
        :heights="1000"
        :scalex="5"
        :scaley="4"
      />
      <img
        class="tech-title"
        v-lazy="require(`../../assets/images/wap/tech-title.png`)"
        alt=""
      />
      <div class="card first-card">
        <div class="title">Blockchain consulting</div>
        <div class="info-box">
          Providing advice on blockchain technology and business to help clients determine their blockchain strategy.
        </div>
        <div
          class="btn-details"
          @click="toTechDetails('0')"
        >Details →</div>
      </div>
      <div class="card">
        <div class="title">Blockchain architecture design</div>
        <div class="info-box">
          Helping clients determine a blockchain architecture that fits their business requirements.
        </div>
        <div
          class="btn-details"
          @click="toTechDetails('1')"
        >Details →</div>
      </div>
      <div class="card">
        <div class="title">Smart contract development</div>
        <div class="info-box">Helping clients develop smart contracts to implement their business logic.</div>
        <div
          class="btn-details"
          @click="toTechDetails('2')"
        >Details →</div>
      </div>
      <div class="card">
        <div class="title">Blockchain application development</div>
        <div class="info-box">
          Developing blockchain applications using open source or custom blockchain technology.
        </div>
        <div
          class="btn-details"
          @click="toTechDetails('3')"
        >Details →</div>
      </div>
      <div class="card">
        <div class="title">Digital asset management</div>
        <div class="info-box">
          Helping clients manage their digital assets, including creating, issuing, and managing digital assets.
        </div>
        <div
          class="btn-details"
          @click="toTechDetails('4')"
        >Details →</div>
      </div>
      <div class="card">
        <div class="title">Maintenance and support</div>
        <div class="info-box">
          Providing maintenance and support for blockchain technology to ensure its proper operation.
        </div>
        <div
          class="btn-details"
          @click="toTechDetails(5)"
        >Details →</div>
      </div>
    </section>
    <section
      class="h5-page-3"
      id="03"
      :style="{ 'background-image': `url(${backgroundImage3})` }"
    >
      <div class="box-particles">
        <vue-particles
          v-if="isParticles"
          color="#28e4fa"
          :particleOpacity="1"
          :particlesNumber="150"
          shapeType="circle"
          :particleSize="2"
          linesColor="#0293dd"
          :linesWidth="0"
          :lineLinked="false"
          :lineOpacity="1"
          :linesDistance="60"
          :moveSpeed="3"
          :hoverEffect="false"
          hoverMode="grab"
          :clickEffect="false"
          clickMode="push"
          style="margin: 0 auto; width: 100%; height: 100%; border-radius: 50%; overflow: hidden"
        />
      </div>
      <img
        class="about-title"
        v-lazy="require('../../assets/images/wap/about-title.png')"
        alt=""
      />
      <img
        class="imgall"
        v-lazy="require('../../assets/images/about/imgall.png')"
        alt=""
      />
      <div class="font-info">
        Superchain Attica Pte. Ltd. is headquartered in Singapore and has received investments from multiple institutions in
        Southeast Asia. We provide cutting-edge blockchain technology solutions to businesses across various industries.
        Our team of experts specializes in blockchain architecture, smart contract development, and digital asset
        management. We help our clients leverage the full potential of blockchain technology to scale their business.
        Whether its streamlining your operations, securing digital assets, or creating new revenue streams, our team is
        here to support you every step of the way.
      </div>
      <div class="Project-case">
        Project case:
        <a
          href="https://www.genuniverse.io/"
          target="_blank"
        >
          <img
            class="gutlogo"
            v-lazy="require('../../assets/images/wap/gutlogo.png')"
            alt=""
          />
        </a>
      </div>
    </section>
    <section
      class="h5-page-4"
      id="04"
      :style="{ 'background-image': `url(${backgroundImage4})` }"
    >
      <Star
        :nums="50"
        :heights="350"
        :scalex="5"
        :scaley="4"
      />
      <img
        class="joinus-title"
        v-lazy="require('../../assets/images/wap/joinus-title.png')"
        alt=""
      />
      <div class="look-box">
        <img
          v-lazy="require('../../assets/images/join-us/look-for.png')"
          alt=""
        />
        <div class="we-look">We are looking for</div>
      </div>
      <img
        class="theplanet"
        v-lazy="require(`../../assets/images/join-us/theplanet.png`)"
        alt=""
      />
      <div class="swiper-box">
        <swiper :options="swiperOption">
          <swiper-slide>
            <div class="swiper-bg">
              <img
                src="../../assets/images/join-us/SCDE.png"
                alt=""
              />
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="swiper-bg">
              <img
                src="../../assets/images/join-us/BPM.png"
                alt=""
              />
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="swiper-bg">
              <img
                src="../../assets/images/join-us/OAD.png"
                alt=""
              />
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="swiper-bg">
              <img
                src="../../assets/images/join-us/MOS.png"
                alt=""
              />
            </div>
          </swiper-slide>
        </swiper>
        <div
          class="swiper-button-prev"
          slot="button-prev"
        ></div>
        <div
          class="swiper-button-next"
          slot="button-next"
        ></div>
      </div>
      <div class="mailto">Email:hr-info@superchain.io</div>
    </section>
    <section
      class="h5-page-5"
      id="05"
      :style="{ 'background-image': `url(${backgroundImage5})` }"
    >
      <Star
        :nums="100"
        :heights="500"
        :scalex="5"
        :scaley="4"
      />
      <img
        class="getintouch"
        v-lazy="require(`../../assets/images/contact/getintouch-title.png`)"
        alt=""
      />

      <div class="ball-box">
        <div class="particles-warp">
          <vue-particles
            v-if="!isParticles"
            color="#28e4fa"
            :particleOpacity="1"
            :particlesNumber="150"
            shapeType="circle"
            :particleSize="1.5"
            linesColor="#0293dd"
            :linesWidth="0"
            :lineLinked="false"
            :lineOpacity="1"
            :linesDistance="60"
            :moveSpeed="3"
            :hoverEffect="false"
            hoverMode="grab"
            :clickEffect="false"
            clickMode="push"
            style="margin: 0 auto; width: 100%; height: 100%; border-radius: 50%; overflow: hidden"
          />
        </div>
        <div class="mail">
          <img
            class="child-img"
            v-lazy="require(`../../assets/images/contact/mail.png`)"
            alt=""
          />
          <div class="mail-font Mail1">EMAIL</div>
          <div class="last-indr">business@superchain.io</div>
        </div>
        <div class="mail middle-top">
          <img
            class="child-img Address-img"
            v-lazy="require(`../../assets/images/contact/address.png`)"
            alt=""
          />
          <div class="mail-font">ADDRESS</div>
          <div class="Address-font first-add">6601 Beach Road #22-01</div>
          <div class="Address-font">Golden Mile Tower Singapore(199589)</div>
        </div>
      </div>

      <div class="wap-footer">
        <Footer />
      </div>
    </section>
  </div>
</template>
<script>
import 'swiper/css/swiper.min.css';
import 'vue-awesome-swiper/node_modules/swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import DrawerYayout from '@/components/drawer-layout.vue';
import Star from '@/components/star.vue';
import { imgSuffix } from '../../utils/common';
import Footer from '@/components/footer.vue'
export default {
  name: 'wapHome',
  components: {
    swiper,
    swiperSlide,
    DrawerYayout,
    Star,
    Footer
  },
  data() {
    return {
      openMeun: false,
      swiperOption: {
        //swiper3
        // autoplay: 3000,
        speed: 1000,
        prevButton: '.swiper-button-prev',
        nextButton: '.swiper-button-next',
      },
      isParticles: true,
      scrollY: 0,
      backgroundImage1: require('../../assets/images/wapBg/bg1.png' + imgSuffix),
      backgroundImage2: require('../../assets/images/wapBg/bg2.png' + imgSuffix),
      backgroundImage3: require('../../assets/images/wapBg/bg3.png' + imgSuffix),
      backgroundImage4: require('../../assets/images/wapBg/bg4.png' + imgSuffix),
      backgroundImage5: require('../../assets/images/wapBg/bg5.png' + imgSuffix),
    };
  },
  methods: {
    closeMe(v) {
      // 获取到组件抽屉是否是打开还是关闭状态
      if (v) {
        document.querySelector('body').setAttribute('style', 'overflow: hidden;'); // 侧边栏出来的时候禁止滚动
      } else {
        document.querySelector('body').setAttribute('style', 'overflow: initial;'); // 恢复滚动
      }
      this.openMeun = v; // 恢复状态
    },
    leftMenuHandle() {
      this.openMeun = true;
    },
    toTechDetails(num) {
      this.$store.commit('setTechTabIndex', num);
      this.$router.push({ name: 'TechDetails', query: { titleId: num } });
    },
    handleScroll() {
      this.$nextTick(() => {
        let top = document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset;
        this.scrollY = top;
        if (top > 2226) {
          this.isParticles = false;
        } else {
          this.isParticles = true;
        }
      });
    },
  },
  mounted() {
    window.addEventListener('beforeunload', (e) => {
      window.scroll(0, 0); //页面刷新回到顶部
    });
    window.addEventListener('scroll', this.handleScroll, true);
  },
  destroyed() { },
};
</script>

<style lang="scss" scoped>
.wap.Home {
  position: relative;
  width: 100%;
  background: #000;
  .h5-page-1 {
    position: relative;
    width: 100%;
    // background-image: url('../../assets/images/wapBg/bg1.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    padding-bottom: 0.3rem;
    overflow: hidden;
    .head {
      position: fixed;
      top: 0;
      left: 0;
      height: 0.44rem;
      width: 100%;
      background-color: #00000f;
      z-index: 122;
      .menu-logo {
        position: absolute;
        top: 12px;
        left: 12px;
        width: 0.25rem;
        height: 0.2rem;
      }
      .hooked-logo {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 30%;
        height: auto;
      }
    }

    .build-box {
      padding-top: 0.75rem;
      img {
        width: 2.5rem;
        height: 1.33rem;
        display: block;
        margin: 0 auto;
      }
    }
    .hand-pointer {
      position: relative;
      display: block;
      width: 200px;
      height: 270px;
      margin: auto;
      margin-top: 23px;
      z-index: 12;
    }
  }
  .h5-page-2 {
    position: relative;
    width: 100%;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: right 0px bottom 0;
    padding-top: 60px;
    overflow: hidden;

    .tech-title {
      position: absolute;
      top: 20px;
      left: 50%;
      transform: translateX(-50%);
      width: 98%;
      height: auto;
    }

    .card {
      width: 90%;
      background-image: url("../../assets/images/technical-service/frame.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      margin: 0 auto;
      padding: 0.02rem 0.14rem;
      box-sizing: border-box;
      margin-top: 25px;
      .title {
        padding: 10px 0;
        box-sizing: border-box;
        text-align: center;
        font-family: Verdana, Geneva, sans-serif;
        font-size: 14px;
        color: #ffffff;
        letter-spacing: 0;
        font-weight: 600;
        background: linear-gradient(85deg, #28e4fa 0.4150390625%, #1764cd 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .info-box {
        font-family: Verdana, Geneva, sans-serif;
        font-size: 12px;
        color: #ffffff;
        letter-spacing: 0;
        font-weight: 400;
        line-height: 17px;
      }

      .btn-details {
        width: 100px;
        height: 25px;
        line-height: 25px;
        text-align: center;
        font-family: Verdana, Geneva, sans-serif;
        font-size: 12px;
        color: #ffffff;
        letter-spacing: 0;
        font-weight: 400;
        background-image: linear-gradient(90deg, #28e4fa 0%, #1764cd 100%),
          linear-gradient(90deg, #28e4fa 0%, #2f06ff 100%);
        border-radius: 3.5px;
        margin: auto;
        margin-top: 17px;
        margin-bottom: 20px;
      }
    }
  }
  .h5-page-3 {
    position: relative;
    width: 100%;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    // height: 8.5rem;
    overflow: hidden;
    padding-bottom: 0.3rem;
    .box-particles {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
    }
    .about-title {
      display: block;
      margin: 0 auto;
      padding-top: 0.6rem;
    }
    .imgall {
      display: block;
      width: 2.65rem;
      height: auto;
      margin: 0 auto;
      margin-top: 0.4rem;
    }
    .font-info {
      padding: 0.2rem;
      box-sizing: border-box;
      font-family: Verdana, Geneva, sans-serif;
      font-size: 12px;
      color: #ffffff;
      letter-spacing: 0;
      font-weight: 600;
      line-height: 20px;
    }
    .Project-case {
      position: relative;
      margin-top: 0.1rem;
      font-family: Verdana, Geneva, sans-serif;
      font-size: 12px;
      color: #ffffff;
      letter-spacing: 0;
      font-weight: 600;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 101;
      .gutlogo {
        margin-left: 10px;
        width: 100px;
        height: auto;
      }
    }
  }
  .h5-page-4 {
    position: relative;
    width: 100%;
    // background-image: url('../../assets/images/wapBg/bg4.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    padding-top: 1.4rem;
    padding-bottom: 1rem;
    overflow: hidden;
    .joinus-title {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 0.1rem;
    }
    .look-box {
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 0.16rem;
        height: 0.17rem;
        margin-right: 0.05rem;
      }
      .we-look {
        font-family: Verdana, Geneva, sans-serif;
        font-size: 15px;
        color: #ffffff;
        letter-spacing: 0;
        text-align: center;
        font-weight: 600;
        background: linear-gradient(85deg, #28e4fa 0.4150390625%, #1764cd 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }

    .theplanet {
      position: absolute;
      right: 0.15rem;
      top: 1rem;
      width: 1.01rem;
      height: 1.55rem;
    }

    @media screen and (max-width: 320px) {
      .theplanet {
        right: 0.02rem;
      }
    }

    @media (min-width: 321px) and (max-width: 360px) {
      .theplanet {
        right: 0.02rem;
      }
    }

    .swiper-box {
      display: block;
      margin: 0 auto;
      margin-top: 0.26rem;
      .swiper-bg {
        width: 78%;
        height: auto;
        margin: auto;
        img {
          display: block;
          width: 100%;
          height: auto;
          margin: auto;
        }
        .introduce {
          margin-top: 0.1rem;
          padding: 0 0.25rem;
          box-sizing: border-box;
          font-family: Verdana, Geneva, sans-serif;
          font-size: 12px;
          color: #ffffff;
          letter-spacing: 0;
          line-height: 0.22rem;
          font-weight: 600;
        }
      }
    }
    .mailto {
      margin-top: 0.2rem;
      font-family: Verdana, Geneva, sans-serif;
      font-size: 12px;
      background: linear-gradient(
        to right,
        #28e4fa 0.4150390625%,
        #0197ff 100%
      );
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      letter-spacing: 0;
      text-align: center;
      font-weight: 400;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .h5-page-5 {
    position: relative;
    width: 100%;
    height: 4.3rem;
    // background-image: url('../../assets/images/wapBg/bg5.png');
    background-size: cover;
    background-repeat: no-repeat;
    padding-top: 1rem;
    overflow: hidden;
    .ball-box {
      position: absolute;
      top: 47%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 3rem;
      height: 3rem;
      background-image: url("../../assets/images/wapBg/globe.png");
      background-size: cover;
      background-repeat: no-repeat;
      .particles-warp {
        position: absolute;
        top: 52%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 2.68rem;
        height: 2.68rem;
        border-radius: 50%;
        overflow: hidden;
        z-index: 111;
      }
    }
    .getintouch {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 0;
    }
    .mail {
      width: 2rem;
      height: 1.63rem;
      background-image: url("../../assets/images/contact/contace-frame.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      .child-img {
        margin-top: 0.1rem;
        width: auto;
        height: 0.72rem;
      }
      .Mail1 {
        margin-top: 0.1rem;
      }
      .mail-font {
        font-family: Verdana, Geneva, sans-serif;
        font-size: 16px;
        color: #ffffff;
        letter-spacing: 0;
        text-align: center;
        font-weight: 600;
        background: linear-gradient(85deg, #28e4fa 0.4150390625%, #4c7fff 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }

      .last-indr {
        margin-top: 0.1rem;
        font-family: Verdana, Geneva, sans-serif;
        font-size: 12px;
        color: #ffffff;
        letter-spacing: 0;
        text-align: center;
        font-weight: 400;
      }

      @media screen and (max-width: 320px) {
        .last-indr {
          transform: scale(0.8);
        }
      }

      @media (min-width: 321px) and (max-width: 360px) {
        .last-indr {
          transform: scale(0.9);
        }
      }
      .first-add {
        margin-top: 0.1rem;
      }
      .Address-font {
        font-family: Verdana, Geneva, sans-serif;
        font-size: 11px;
        color: #ffffff;
        letter-spacing: 0;
        text-align: center;
        font-weight: 400;
      }
      @media screen and (max-width: 320px) {
        .Address-font {
          transform: scale(0.8);
        }
      }

      @media (min-width: 321px) and (max-width: 360px) {
        .Address-font {
          transform: scale(0.9);
        }
      }
    }

    .middle-top {
      margin-top: 0.3rem;
      padding: 0 5px;
      box-sizing: border-box;
    }
    .wap-footer {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0.29rem;
      font-family: Verdana, Geneva, sans-serif;
      font-size: 12px;
      color: #ffffff;
      letter-spacing: 0;
      font-weight: 400;
      text-align: center;
      white-space: nowrap;
    }
  }
}
</style>

<style>
.swiper-button-prev:after,
.swiper-container-rtl .swiper-button-next:after {
  content: "";
}
.swiper-button-prev,
.swiper-container-rtl .swiper-button-next {
  width: 0.4rem;
  height: 0.375rem;
  left: 0 !important;
  top: 55%;
  background-image: url("../../assets/images/join-us/left.png");
  background-size: 59% 71%;
}
.swiper-button-next:after,
.swiper-container-rtl .swiper-button-prev:after {
  content: "";
}
.swiper-button-next,
.swiper-container-rtl .swiper-button-prev {
  width: 40px;
  height: 37.5px;
  right: 0 !important;
  top: 55%;
  background-image: url("../../assets/images/join-us/right.png");
  background-size: 59% 71%;
}
</style>
